import {FunctionComponent, useEffect} from 'react';

interface TagManagerInitializationProps {
  id?: string | null;
}

const TagManagerInitializer: FunctionComponent<TagManagerInitializationProps> = ({id}) => {
  useEffect(() => {
    if (!id) {
      return;
    }

    const script = document.createElement('script');
    script.src = `https://www.googletagmanager.com/gtm.js?id=${id}&l=dataLayer`;
    script.async = true;

    const initScript = document.createElement('script');
    initScript.async = true;
    initScript.id = 'gtm-init';
    initScript.innerHTML = `
      window.dataLayer = window.dataLayer || [];
      window.dataLayer.push({'gtm.start': new Date().getTime(), 'event': 'gtm.js'});
      function gtag(){dataLayer.push(arguments);}
    `;

    document.head.appendChild(script);
    document.head.appendChild(initScript);

    return () => {
      document.head.removeChild(script);
      document.head.removeChild(initScript);
    };
  }, [id]);

  return null;
};

export default TagManagerInitializer;
